import Component from '../abstracts/Component';

export default class DropdownComponent extends Component {

  get SELECTORS() {
    return {
      utilityBoxTitle: '.utility-box-title',
      utilityBoxDescription: '.utility-box-title__description',
      sizesSubsection: '.sizes-subsection',
      iconSpan: 'span:not(.utility-box-title__description)',
      arrow: '[data-arrow]'
    }
  }

  get CLASSES() {
    return {
      open: 'open',
      selected: 'selected',
      hidden: 'hidden',
      chevronUp: 'icon-chevron-up',
      chevronDown: 'icon-chevron-down'
    }
  }

  bindEvents() {
    let ctx = this;

    $(document).on("click", ctx.SELECTORS.utilityBoxTitle, function (event) {
      event.stopPropagation();
      event.preventDefault();

      if ($(ctx.SELECTORS.sizesSubsection).length >= 1) {
        $(this).toggleClass(ctx.CLASSES.open);
        $(this).next('div').stop(true, false).slideToggle();

        //closes other dropdown(s) when a new one is opened
        if ($(ctx.SELECTORS.sizesSubsection).length >= 1) {
          let contents = document.querySelectorAll(ctx.SELECTORS.utilityBoxTitle);
          contents.forEach(function (content) {
            if ($(content).hasClass(ctx.CLASSES.selected) && $(content).hasClass(ctx.CLASSES.open)) {
              $(content).toggleClass(ctx.CLASSES.open);
              $(content).removeClass(ctx.CLASSES.selected);
              $(content).find(ctx.SELECTORS.utilityBoxDescription).addClass(ctx.CLASSES.hidden);
              $(content).next('div').stop(true, false).slideToggle();
              $(content).find(ctx.SELECTORS.arrow).removeClass(ctx.CLASSES.chevronUp);
              $(content).find(ctx.SELECTORS.arrow).addClass(ctx.CLASSES.chevronDown);
            }
          });
          $(this).toggleClass(ctx.CLASSES.selected);
        }

        if ($(this).find(ctx.SELECTORS.arrow).hasClass(ctx.CLASSES.chevronDown)) {
          $(this).find(ctx.SELECTORS.arrow).removeClass(ctx.CLASSES.chevronDown);
          $(this).find(ctx.SELECTORS.arrow).addClass(ctx.CLASSES.chevronUp);
          $(this).find(ctx.SELECTORS.utilityBoxDescription).removeClass(ctx.CLASSES.hidden);
        } else {
          $(this).find(ctx.SELECTORS.arrow).removeClass(ctx.CLASSES.chevronUp);
          $(this).find(ctx.SELECTORS.arrow).addClass(ctx.CLASSES.chevronDown);
          $(this).find(ctx.SELECTORS.utilityBoxDescription).addClass(ctx.CLASSES.hidden);
        }
      }
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }

}
